import { render, staticRenderFns } from "./fccKanban.vue?vue&type=template&id=35468183&scoped=true"
import script from "./fccKanban.vue?vue&type=script&lang=js"
export * from "./fccKanban.vue?vue&type=script&lang=js"
import style0 from "./fccKanban.vue?vue&type=style&index=0&id=35468183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35468183",
  null
  
)

export default component.exports